'use client'
import Script from "next/script";
import { useEffect, useState } from "react";
import { shouldSkipAnalytics } from "@/app/utils/analytics";

const GoogleAnalytics = ({ ga_id }: { ga_id: string }) => {
  // Use lazy initialization to get the correct initial value
  const [analyticsState, setAnalyticsState] = useState<{
    isLoaded: boolean;
    skipAnalytics: boolean;
  }>({ isLoaded: false, skipAnalytics: true });
  
  useEffect(() => {
    // Check the value on the client side
    setAnalyticsState({
      isLoaded: true,
      skipAnalytics: shouldSkipAnalytics()
    });
  }, []);

  // Don't render anything until we've checked the analytics settings
  if (!analyticsState.isLoaded) {
    return null;
  }

  // Don't render scripts if analytics should be skipped
  if (analyticsState.skipAnalytics) {
    return null;
  }

  return (
    <>
      <Script
        async
        src={`https://www.googletagmanager.com/gtag/js? 
        id=${ga_id}`}
      ></Script>
      <Script
        id="google-analytics"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
  
            gtag('config', '${ga_id}');
          `,
        }}
      ></Script>
      <Script
        id="gtag-event-helper"
        dangerouslySetInnerHTML={{
          __html: `
            <!-- Google tag (gtag.js) event - delayed navigation helper -->
            function gtagSendEvent(url) {
              var callback = function () {
                if (typeof url === 'string') {
                  window.location = url;
                }
              };
              gtag('event', 'ads_conversion_PURCHASE_1', {
                'event_callback': callback,
                'event_timeout': 2000,
                // <event_parameters>
              });
              return false;
            }
          `,
        }}
      ></Script>
      <Script
        id="twitter-pixel-base"
        dangerouslySetInnerHTML={{
          __html: `!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);},s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');twq('config','q1rsh');`
        }}
      />
    </>
  );
};

export default GoogleAnalytics;
